import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { Paper, Grid, Divider, Typography, IconButton, Link, Button } from '@material-ui/core';

import { Search as SearchIcon } from '@material-ui/icons';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Keyboard, Profil, ChooseSiteDialog } from './components';

import TabControl from './TabControl';
import UserProfile from '../../../../UserProfile';

const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        flexGrow: 1
    }
});

class Creation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            step: 0,
            kabis: '',
            selectedKabis: '',
            openSiteDialog: false,
            metiers: [],
            isLoading: false,
            company: null,
            availabality: null,
            mandataire: null,
            match: false,
            totalSites: 0,
            totalSitesEnable: 0,
            totalSitesDisable: 0,
            totalIn: 0,
            totalNotIn: 0,
            choosenKey: false,
            hasOpposed: false,
            regexp: /^[0-9\b]+$/
        };
    }

    componentDidUpdate = (prevProps, prevState) => {
        this.state.isLoading && prevState.isLoading != this.state.isLoading && this.getData();
        //prevState.data != this.state.data && this.setState({ step: 1 })
    };

    getData = () => {
        const { kabis } = this.state;

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/merchant/search?kabis=${kabis}&domaine=1`,
            {
                method: 'GET'
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                if (!data.match) {
                    alert('SIRET ou SIREN introuvable.');
                    this.setState({
                        openSiteDialog: false,
                        isLoading: false
                    });
                    return;
                }

                this.setState({
                    openSiteDialog: true,
                    isLoading: false,
                    ...data
                });
            })
            .catch(
                error => {
                    console.error(error);
                    alert('SIRET ou SIREN introuvable.');
                    this.setState({
                        openSiteDialog: false,
                        isLoading: false
                    });
                } // Handle the error response object
            );
    };

    sendData = data => {
        const { selectedKabis } = this.state;

        const formData = new FormData();
        formData.append('kabis', selectedKabis);
        formData.append('tel', data.telephone);
        formData.append('link', data.internet);
        formData.append('mail', data.mail);
        //formData.append("assureur", data.assurance);
        formData.append('dateFinAssurance', data.dateFinAssurance);
        formData.append('numeroPolice', data.numeroPoliceAssurance);
        formData.append('enseigne', data.enseigne);
        data.aot != '' && formData.append('aot', data.aot);
        data.aotFile && formData.append('aotFile', data.aotFile);
        data.assuranceFile && formData.append('assuranceFile', data.assuranceFile);
        formData.append('username', UserProfile.getName());
        formData.append('domaine', 1);
        formData.append('hasOpposed', data.hasOpposed);

        fetch(
            `https://www.${
                window.location.hostname.split('.')[1]
                    ? window.location.hostname.split('.')[0] === 'www'
                        ? window.location.hostname.split('.')[1]
                        : window.location.hostname.split('.')[0]
                    : 'dev'
            }.api.digitmarche.fr/api/merchant/new`,
            {
                method: 'POST',
                body: formData
            }
        )
            .then(response => {
                return response.ok ? response.json() : false;
            })
            .then(data => {
                if (data) {
                    alert('Commerçant créé avec succès');
                    this.props.history.push(`/domain-merchants/get/${data.siret}/profil`);
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            })
            .catch(
                error => {
                    console.error(error);
                    alert('Echec de la création.');
                    this.setState({
                        isLoading: false
                    });
                } // Handle the error response object
            );
    };

    handleKabis = value => {
        (value === '' || this.state.regexp.test(value)) &&
            this.setState({
                kabis: value.slice(0, 14)
            });
    };

    handleStep = step => {
        this.setState({
            step: step
        });
    };

    getBack = () => {
        const { history } = this.props;
        history.goBack();
    };

    handleDialog = () => {
        this.setState({
            openSiteDialog: false
        });
    };

    handleLoading = value => {
        this.setState({
            isLoading: value
        });
    };

    handleChoosenKey = value => {
        this.setState({
            choosenKey: value
        });
    };

    handleSelectedKabis = (kabis, choosenKey) => {
        this.setState({
            selectedKabis: kabis,
            choosenKey: choosenKey
        });
    };

    render() {
        const {
            classes,
            step,
            kabis,
            openSiteDialog,
            isLoading,
            choosenKey,
            selectedKabis,
            company,
            sites,
            metiers,
            availabality,
            mandataire,
            totalSites,
            hasOpposed
        } = this.state;

        return (
            <Paper className={classes.root}>
                {openSiteDialog && (
                    <ChooseSiteDialog
                        close={this.handleDialog}
                        setKabis={this.handleSelectedKabis}
                        setChoosenKey={this.handleChoosenKey}
                        nextStep={this.handleStep}
                        data={{
                            company: company,
                            sites: sites,
                            availabality: availabality,
                            mandataire: mandataire,
                            choosenKey: choosenKey,
                            kabis: kabis,
                            selectedKabis: selectedKabis,
                            totalSites: totalSites,
                            hasOpposed: hasOpposed
                        }}
                    />
                )}
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Grid container direction="row" alignItems="baseline">
                            <Grid item>
                                <IconButton onClick={this.getBack}>
                                    <ArrowBackIcon />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography>
                                    <Link component={RouterLink} to="/domain-merchants/all">
                                        Les commerçants du domaine
                                    </Link>{' '}
                                    / Créer un commerçant
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Divider />
                    </Grid>
                    {step == 1 && (
                        <Grid item>
                            <Button
                                style={{ float: 'right' }}
                                onClick={() => this.handleStep(0)}
                                variant="contained"
                                color="primary">
                                <SearchIcon /> Nouvelle recherche
                            </Button>
                        </Grid>
                    )}
                    <Grid item>
                        <TabControl value={step} index={0}>
                            <Keyboard
                                isLoading={isLoading}
                                setLoading={this.handleLoading}
                                setKabis={this.handleKabis}
                                kabis={kabis}
                            />
                        </TabControl>
                        <TabControl value={step} index={1}>
                            <Profil
                                data={{
                                    company: company,
                                    sites: sites,
                                    availabality: availabality,
                                    mandataire: mandataire,
                                    choosenKey: choosenKey,
                                    kabis: kabis,
                                    selectedKabis: selectedKabis,
                                    totalSites: totalSites,
                                    metiers: metiers,
                                    hasOpposed: hasOpposed
                                }}
                                isLoading={isLoading}
                                setIsLoading={this.handleLoading}
                                sendData={this.sendData}
                            />
                        </TabControl>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

export default withStyles(styles)(Creation);
